import React from 'react';
import { Button, List, Typography } from 'antd';
import { DownloadOutlined, FileTextOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';
import { INCIDENT_DOCUMENT_TEMPLATES, downloadTemplate } from '../../data/documentTemplates';

const NotesTab = ({ incidentId }) => {

  return (
    <div className="document-templates-container">
      {/* Document Templates Section */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="h5 mb-0">📋 Document Templates</h3>
        <Typography.Text type="secondary" style={{ fontSize: '12px' }}>
          Download templates to fill out offline
        </Typography.Text>
      </div>

      <List
        dataSource={INCIDENT_DOCUMENT_TEMPLATES}
        renderItem={(template) => (
          <List.Item
            actions={[
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={() => {
                  downloadTemplate(template);
                  toast.success(`📥 ${template.name} downloaded successfully`);
                }}
                style={{
                  backgroundColor: '#39325b',
                  borderColor: '#39325b'
                }}
                title={`Download ${template.name}`}
              >
                Download
              </Button>
            ]}
            style={{
              padding: '16px',
              border: '1px solid #f0f0f0',
              borderRadius: '6px',
              marginBottom: '8px',
              backgroundColor: '#fafafa'
            }}
          >
            <List.Item.Meta
              avatar={<FileTextOutlined style={{ fontSize: '20px', color: '#39325b' }} />}
              title={
                <Typography.Text strong style={{ fontSize: '15px' }}>
                  {template.name}
                </Typography.Text>
              }
              description={
                <div>
                  <Typography.Text type="secondary" style={{ fontSize: '13px' }}>
                    {template.description}
                  </Typography.Text>
                  <br />
                  <Typography.Text type="secondary" style={{ fontSize: '12px' }}>
                    File: {template.filename}
                  </Typography.Text>
                </div>
              }
            />
          </List.Item>
        )}
      />
    </div>
  );
};

export default NotesTab; 